import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationBottomBar = (props: Props) => {
  return (
    <View style={styles.container} pointerEvents="box-none">
      {props.withGradient ? (
        <>
          <LinearGradient
            style={styles.gradientContainer}
            pointerEvents="none"
            colors={GRADIENT_COLORS.BACK_LAYER}
          />
          <LinearGradient
            style={styles.gradientContainer}
            pointerEvents="none"
            colors={GRADIENT_COLORS.FRONT_LAYER}
          />
        </>
      ) : null}

      <View style={styles.contentContainer} pointerEvents="box-none">
        {props.children}
      </View>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const GRADIENT_COLORS = {
  BACK_LAYER: [
    theme.colors.OPACITY.BLACK.TRANSPARENT,
    theme.colors.OPACITY.BLACK.LIGHTEST,
  ] as const,
  FRONT_LAYER: [
    theme.colors.OPACITY.OATMEAL.TRANSPARENT,
    theme.colors.OPACITY.OATMEAL.DARKER,
  ] as const,
};

const GRADIENT_CONTAINER_HEIGHT = 40;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
  },
  gradientContainer: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    left: 0,
    height: GRADIENT_CONTAINER_HEIGHT,
  },
  contentContainer: {
    alignItems: 'flex-end',
    gap: theme.spacing['3'],
    padding: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  withGradient?: boolean;
}>;
